import React from 'react';

export const LayoutLeftIcon = () => (
  <svg width="146" height="88" viewBox="0 0 146 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_740_26166)">
      <rect width="146" height="88" rx="4" fill="black" />
      <path
        d="M140.267 62.9159H41.4735C40.3984 62.9159 39.5269 63.6523 39.5269 64.5608V80.1869C39.5269 81.0954 40.3984 81.8318 41.4735 81.8318H140.267C141.342 81.8318 142.214 81.0954 142.214 80.1869V64.5608C142.214 63.6523 141.342 62.9159 140.267 62.9159Z"
        fill="#211E27"
      />
      <path
        d="M44.3936 65.7944C44.3936 65.1131 43.74 64.5608 42.9336 64.5608C42.1273 64.5608 41.4736 65.1131 41.4736 65.7944C41.4736 66.4758 42.1273 67.0281 42.9336 67.0281C43.74 67.0281 44.3936 66.4758 44.3936 65.7944Z"
        fill="#100F12"
      />
      <path
        d="M62.1083 64.5608H47.8003C46.994 64.5608 46.3403 65.1131 46.3403 65.7944C46.3403 66.4758 46.994 67.0281 47.8003 67.0281H62.1083C62.9147 67.0281 63.5683 66.4758 63.5683 65.7944C63.5683 65.1131 62.9147 64.5608 62.1083 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M81.2826 64.5608H66.9746C66.1683 64.5608 65.5146 65.1131 65.5146 65.7944C65.5146 66.4758 66.1683 67.0281 66.9746 67.0281H81.2826C82.089 67.0281 82.7426 66.4758 82.7426 65.7944C82.7426 65.1131 82.089 64.5608 81.2826 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M100.457 64.5608H86.1495C85.3431 64.5608 84.6895 65.1131 84.6895 65.7944C84.6895 66.4758 85.3431 67.0281 86.1495 67.0281H100.457C101.264 67.0281 101.917 66.4758 101.917 65.7944C101.917 65.1131 101.264 64.5608 100.457 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M119.632 64.5608H105.324C104.518 64.5608 103.864 65.1131 103.864 65.7944C103.864 66.4758 104.518 67.0281 105.324 67.0281H119.632C120.439 67.0281 121.092 66.4758 121.092 65.7944C121.092 65.1131 120.439 64.5608 119.632 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M138.807 64.5608H124.499C123.693 64.5608 123.039 65.1131 123.039 65.7944C123.039 66.4758 123.693 67.0281 124.499 67.0281H138.807C139.613 67.0281 140.267 66.4758 140.267 65.7944C140.267 65.1131 139.613 64.5608 138.807 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M44.3936 70.1808C44.3936 69.4995 43.74 68.9471 42.9336 68.9471C42.1273 68.9471 41.4736 69.4995 41.4736 70.1808C41.4736 70.8621 42.1273 71.4144 42.9336 71.4144C43.74 71.4144 44.3936 70.8621 44.3936 70.1808Z"
        fill="#100F12"
      />
      <path
        d="M62.1083 68.9471H47.8003C46.994 68.9471 46.3403 69.4995 46.3403 70.1808C46.3403 70.8621 46.994 71.4144 47.8003 71.4144H62.1083C62.9147 71.4144 63.5683 70.8621 63.5683 70.1808C63.5683 69.4995 62.9147 68.9471 62.1083 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M81.2826 68.9471H66.9746C66.1683 68.9471 65.5146 69.4995 65.5146 70.1808C65.5146 70.8621 66.1683 71.4144 66.9746 71.4144H81.2826C82.089 71.4144 82.7426 70.8621 82.7426 70.1808C82.7426 69.4995 82.089 68.9471 81.2826 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M100.457 68.9471H86.1495C85.3431 68.9471 84.6895 69.4995 84.6895 70.1808C84.6895 70.8621 85.3431 71.4144 86.1495 71.4144H100.457C101.264 71.4144 101.917 70.8621 101.917 70.1808C101.917 69.4995 101.264 68.9471 100.457 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M119.632 68.9471H105.324C104.518 68.9471 103.864 69.4995 103.864 70.1808C103.864 70.8621 104.518 71.4144 105.324 71.4144H119.632C120.439 71.4144 121.092 70.8621 121.092 70.1808C121.092 69.4995 120.439 68.9471 119.632 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M138.807 68.9471H124.499C123.693 68.9471 123.039 69.4995 123.039 70.1808C123.039 70.8621 123.693 71.4144 124.499 71.4144H138.807C139.613 71.4144 140.267 70.8621 140.267 70.1808C140.267 69.4995 139.613 68.9471 138.807 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M44.3936 74.5668C44.3936 73.8855 43.74 73.3332 42.9336 73.3332C42.1273 73.3332 41.4736 73.8855 41.4736 74.5668C41.4736 75.2482 42.1273 75.8005 42.9336 75.8005C43.74 75.8005 44.3936 75.2482 44.3936 74.5668Z"
        fill="#100F12"
      />
      <path
        d="M62.1083 73.3332H47.8003C46.994 73.3332 46.3403 73.8855 46.3403 74.5668C46.3403 75.2482 46.994 75.8005 47.8003 75.8005H62.1083C62.9147 75.8005 63.5683 75.2482 63.5683 74.5668C63.5683 73.8855 62.9147 73.3332 62.1083 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M81.2826 73.3332H66.9746C66.1683 73.3332 65.5146 73.8855 65.5146 74.5668C65.5146 75.2482 66.1683 75.8005 66.9746 75.8005H81.2826C82.089 75.8005 82.7426 75.2482 82.7426 74.5668C82.7426 73.8855 82.089 73.3332 81.2826 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M100.457 73.3332H86.1495C85.3431 73.3332 84.6895 73.8855 84.6895 74.5668C84.6895 75.2482 85.3431 75.8005 86.1495 75.8005H100.457C101.264 75.8005 101.917 75.2482 101.917 74.5668C101.917 73.8855 101.264 73.3332 100.457 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M119.632 73.3332H105.324C104.518 73.3332 103.864 73.8855 103.864 74.5668C103.864 75.2482 104.518 75.8005 105.324 75.8005H119.632C120.439 75.8005 121.092 75.2482 121.092 74.5668C121.092 73.8855 120.439 73.3332 119.632 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M138.807 73.3332H124.499C123.693 73.3332 123.039 73.8855 123.039 74.5668C123.039 75.2482 123.693 75.8005 124.499 75.8005H138.807C139.613 75.8005 140.267 75.2482 140.267 74.5668C140.267 73.8855 139.613 73.3332 138.807 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M44.3936 78.9532C44.3936 78.2719 43.74 77.7196 42.9336 77.7196C42.1273 77.7196 41.4736 78.2719 41.4736 78.9532C41.4736 79.6346 42.1273 80.1869 42.9336 80.1869C43.74 80.1869 44.3936 79.6346 44.3936 78.9532Z"
        fill="#100F12"
      />
      <path
        d="M62.1083 77.7196H47.8003C46.994 77.7196 46.3403 78.2719 46.3403 78.9532C46.3403 79.6346 46.994 80.1869 47.8003 80.1869H62.1083C62.9147 80.1869 63.5683 79.6346 63.5683 78.9532C63.5683 78.2719 62.9147 77.7196 62.1083 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M81.2826 77.7196H66.9746C66.1683 77.7196 65.5146 78.2719 65.5146 78.9532C65.5146 79.6346 66.1683 80.1869 66.9746 80.1869H81.2826C82.089 80.1869 82.7426 79.6346 82.7426 78.9532C82.7426 78.2719 82.089 77.7196 81.2826 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M100.457 77.7196H86.1495C85.3431 77.7196 84.6895 78.2719 84.6895 78.9532C84.6895 79.6346 85.3431 80.1869 86.1495 80.1869H100.457C101.264 80.1869 101.917 79.6346 101.917 78.9532C101.917 78.2719 101.264 77.7196 100.457 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M119.632 77.7196H105.324C104.518 77.7196 103.864 78.2719 103.864 78.9532C103.864 79.6346 104.518 80.1869 105.324 80.1869H119.632C120.439 80.1869 121.092 79.6346 121.092 78.9532C121.092 78.2719 120.439 77.7196 119.632 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M138.807 77.7196H124.499C123.693 77.7196 123.039 78.2719 123.039 78.9532C123.039 79.6346 123.693 80.1869 124.499 80.1869H138.807C139.613 80.1869 140.267 79.6346 140.267 78.9532C140.267 78.2719 139.613 77.7196 138.807 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M34.0308 5H5.96923C4.88165 5 4 6.03681 4 7.31579V79.6842C4 80.9632 4.88165 82 5.96923 82H34.0308C35.1183 82 36 80.9632 36 79.6842V7.31579C36 6.03681 35.1183 5 34.0308 5Z"
        fill="#A2A4FF"
        fillOpacity="0.3"
      />
      <path
        d="M140.267 4.93457H41.4735C40.3984 4.93457 39.5269 5.671 39.5269 6.57943V57.9813C39.5269 58.8897 40.3984 59.6262 41.4735 59.6262H140.267C141.342 59.6262 142.214 58.8897 142.214 57.9813V6.57943C142.214 5.671 141.342 4.93457 140.267 4.93457Z"
        fill="#211E27"
      />
      <path
        d="M47.3135 53.0467L70.6215 32.6995L81.5233 43.2335L110.004 18.3706L117.423 26.3581L134.427 11.514"
        stroke="#66BB6A"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
